///select2setup.js
import $ from 'jquery'
import 'select2/dist/css/select2.css'
import 'select2'

// Helper function to initialize select2 with validation handlers
function initializeSelect2($element) {
  // Destroy existing select2 if already initialized to prevent conflicts
  if ($element.data('select2')) {
    $element.select2('destroy');
  }

  $element.select2({
    tokenSeparators: [',', ' ']
  }).on('select2:select select2:unselect select2:clear select2:close', function() {
    // Trigger validation when select2 changes - IMMEDIATE
    var form = $(this).closest('form');
    if (typeof window.checkStep1Fields === 'function') {
      setTimeout(window.checkStep1Fields, 5);
      setTimeout(window.checkStep1Fields, 50);
      setTimeout(window.checkStep1Fields, 200);
    }
    if (typeof window.forceEnableStep1Buttons === 'function' && form.attr('id') === 'ad-form-1') {
      setTimeout(window.forceEnableStep1Buttons, 10);
    }
    if (typeof validateAndToggleButtons === 'function') {
      setTimeout(function() {
        validateAndToggleButtons(form);
      }, 50);
    }
  });

  if ($element.attr('id') === 'auction_locations' && typeof window.performAuctionSearch === 'function') {
    $element.on('select2:select select2:unselect select2:clear change', function() {
      if (typeof window.performAuctionSearch === 'function') {
        window.performAuctionSearch();
      }
    });
  }
}

// Function to reinitialize all select2 elements (globally accessible)
function reinitializeSelect2() {
  $('.select2').each(function() {
    initializeSelect2($(this));
  });
}

// Make function globally accessible
window.reinitializeSelect2 = reinitializeSelect2;

// Initialize select2 on page load
$(document).ready(function(){
  reinitializeSelect2();

  $(document).on("click", ".view-more-link", function(){
    reinitializeSelect2();
  });

  $('.clear_auction_locations').click(function() {
    $('#auction_locations').val(null).trigger('change');
  });

  // Listen for DOM updates from ActionCable (auction table updates)
  document.addEventListener('auctionTableUpdated', function() {
    setTimeout(reinitializeSelect2, 100);
  });

  // Reinitialize select2 after AJAX requests complete
  $(document).ajaxSuccess(function(event, xhr, settings) {
    setTimeout(reinitializeSelect2, 100);
  });

  // Also listen for turbolinks if used
  if (typeof Turbolinks !== 'undefined') {
    $(document).on('turbolinks:load', function() {
      setTimeout(reinitializeSelect2, 100);
    });
  }
});